import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const Pagination = ({ page, pageSize, total, onPageChange, testId = 'pagination' }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100" data-testid={testId}>
      <span className="text-sm text-gray-500">
        {from}–{to} de {total} • Página {page} de {totalPages}
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline" size="sm" disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="bg-white border-gray-300 text-gray-700"
          data-testid={`${testId}-prev`}
        >
          <ChevronLeft className="w-4 h-4 mr-1" /> Anterior
        </Button>
        <Button
          variant="outline" size="sm" disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          className="bg-white border-gray-300 text-gray-700"
          data-testid={`${testId}-next`}
        >
          Próxima <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
